import { render, staticRenderFns } from "./UcEmployeeFieldset.yaml?vue&type=template&id=2f627f96&component"
import script from "./UcEmployeeFieldset.yaml?vue&type=script&lang=ts&component"
export * from "./UcEmployeeFieldset.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports